import { IListing } from "./listing.model";

export interface IListings {
  page_num: number;
  page_size: number;
  properties: IListing[];
  resp_type: string;
  total: number;
  loading?: boolean;
  errorMessage?: string;
}

export const defaultValue: Readonly<IListings> = {
  page_num: 0,
  page_size: 0,
  properties: [],
  resp_type: '',
  total: 0,
  loading: false,
  errorMessage: ''
};